import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import SearchBar from '../components/SearchBar';
import { AuthContext } from '../contexts/AuthContext'; // Import AuthContext
import '../styles/HomePageSearchBox.css';

const HomePageSearchBox = () => {
  const [searchTermQuery, setSearchTermQuery] = useState('');
  const [keywordQuery, setKeywordQuery] = useState('');
  const [locationQuery, setLocationQuery] = useState('');
  const navigate = useNavigate();
  const { zipCode } = useContext(AuthContext); // Get zipCode from context
  const { countyName } = useContext(AuthContext); // Get countyName from context

  // Input: User Search Query
  // Output: Sets page to search results and displays query results
  const handleSearch = (e, queryType = 'keyword', queryValue = '') => {
    e.preventDefault();
    // if (!isEnabled) return; // Prevent action if disabled

    const queryParams = new URLSearchParams();
    if (searchTermQuery || queryType === 'searchTerm') queryParams.append('searchTerm', queryType === 'keyword' ? queryValue || searchTermQuery : searchTermQuery);
    if (keywordQuery || queryType === 'keyword') queryParams.append('keyword', queryType === 'keyword' ? queryValue || keywordQuery : keywordQuery);
    if (locationQuery || queryType === 'location') queryParams.append('location', queryType === 'location' ? queryValue || locationQuery : locationQuery);
    if (zipCode && !countyName) { // Include zipCode if available
      queryParams.append('zipCode', zipCode);
    }else if(!zipCode && countyName){ //Include county name if available
      queryParams.append('countyName', countyName);
    }
    navigate(`/search-results?${queryParams.toString()}`);
  };

  return (
    // <div className={`searchContainer ${isEnabled ? '' : 'disabled'}`}>
    <div className= 'searchContainer'>
      <h3 className="search-title">Search Services</h3>
      <form onSubmit={(e) => handleSearch(e, 'keyword')}>
        <SearchBar
          placeholder="Search Services"
          value={searchTermQuery}
          onChange={(e) => setSearchTermQuery(e.target.value)}
          // disabled={!isEnabled}
        />
      </form>
      <h3 className="search-title">Common Searches</h3>
      <button type="button" className="common-search-button" onClick={(e) => handleSearch(e, 'keyword', 'Domestic Abuse')} >Domestic Abuse</button>
      <button type="button" className="common-search-button" onClick={(e) => handleSearch(e, 'keyword', 'Rental Assistance')} >Rental Assistance</button>
      <button type="button" className="common-search-button" onClick={(e) => handleSearch(e, 'keyword', 'Job Search')} >Job Search</button>
    </div>
  );
};

export default HomePageSearchBox;
